/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntryLightReportNewsEntryReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./NewsEntryLightReportNewsEntryReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntrySourceReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntryLightReportNewsEntryReportPaginationSlice);
  }
}(this, function(ApiClient, NewsEntryLightReportNewsEntryReportPaginationSlice) {
  'use strict';




  /**
   * The NewsEntrySourceReport model module.
   * @module model/NewsEntrySourceReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>NewsEntrySourceReport</code>.
   * @alias module:model/NewsEntrySourceReport
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>NewsEntrySourceReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NewsEntrySourceReport} obj Optional instance to populate.
   * @return {module:model/NewsEntrySourceReport} The populated <code>NewsEntrySourceReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('WatchID')) {
        obj['WatchID'] = ApiClient.convertToType(data['WatchID'], 'Integer');
      }
      if (data.hasOwnProperty('CategoryID')) {
        obj['CategoryID'] = ApiClient.convertToType(data['CategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('StakeholderTypeID')) {
        obj['StakeholderTypeID'] = ApiClient.convertToType(data['StakeholderTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ModeratorID')) {
        obj['ModeratorID'] = ApiClient.convertToType(data['ModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('LastCheckDate')) {
        obj['LastCheckDate'] = ApiClient.convertToType(data['LastCheckDate'], 'Date');
      }
      if (data.hasOwnProperty('Entries')) {
        obj['Entries'] = NewsEntryLightReportNewsEntryReportPaginationSlice.constructFromObject(data['Entries']);
      }
      if (data.hasOwnProperty('StakeholderID')) {
        obj['StakeholderID'] = ApiClient.convertToType(data['StakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentWatchStructuredDataSettingsID')) {
        obj['ContentWatchStructuredDataSettingsID'] = ApiClient.convertToType(data['ContentWatchStructuredDataSettingsID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentWatchTableSettingsID')) {
        obj['ContentWatchTableSettingsID'] = ApiClient.convertToType(data['ContentWatchTableSettingsID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentWatchTextSettingsID')) {
        obj['ContentWatchTextSettingsID'] = ApiClient.convertToType(data['ContentWatchTextSettingsID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketRSSWatchSettingID')) {
        obj['MarketRSSWatchSettingID'] = ApiClient.convertToType(data['MarketRSSWatchSettingID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketFeedBingCognitiveID')) {
        obj['MarketFeedBingCognitiveID'] = ApiClient.convertToType(data['MarketFeedBingCognitiveID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceStakeholderID')) {
        obj['SourceStakeholderID'] = ApiClient.convertToType(data['SourceStakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('QualityRatio')) {
        obj['QualityRatio'] = ApiClient.convertToType(data['QualityRatio'], 'Number');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} TypeID
   */
  exports.prototype['TypeID'] = undefined;
  /**
   * @member {Integer} WatchID
   */
  exports.prototype['WatchID'] = undefined;
  /**
   * @member {Integer} CategoryID
   * @default 0
   */
  exports.prototype['CategoryID'] = 0;
  /**
   * @member {Integer} StakeholderTypeID
   */
  exports.prototype['StakeholderTypeID'] = undefined;
  /**
   * @member {Integer} ModeratorID
   * @default 0
   */
  exports.prototype['ModeratorID'] = 0;
  /**
   * @member {Date} LastCheckDate
   */
  exports.prototype['LastCheckDate'] = undefined;
  /**
   * @member {module:model/NewsEntryLightReportNewsEntryReportPaginationSlice} Entries
   */
  exports.prototype['Entries'] = undefined;
  /**
   * @member {Integer} StakeholderID
   */
  exports.prototype['StakeholderID'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} ContentWatchStructuredDataSettingsID
   */
  exports.prototype['ContentWatchStructuredDataSettingsID'] = undefined;
  /**
   * @member {Integer} ContentWatchTableSettingsID
   */
  exports.prototype['ContentWatchTableSettingsID'] = undefined;
  /**
   * @member {Integer} ContentWatchTextSettingsID
   */
  exports.prototype['ContentWatchTextSettingsID'] = undefined;
  /**
   * @member {Integer} MarketRSSWatchSettingID
   */
  exports.prototype['MarketRSSWatchSettingID'] = undefined;
  /**
   * @member {Integer} MarketFeedBingCognitiveID
   */
  exports.prototype['MarketFeedBingCognitiveID'] = undefined;
  /**
   * @member {Integer} SourceStakeholderID
   */
  exports.prototype['SourceStakeholderID'] = undefined;
  /**
   * @member {Number} QualityRatio
   */
  exports.prototype['QualityRatio'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


